<template>
  <footer class="bb-footer">
    <div class="bb-footer-main">
      <div class="bb-footer-grid">
        <section class="bb-footer-brand">
          <div class="bb-footer-logo" @click="$router.push('/')">
            <BrandLogo />
          </div>
          <div class="bb-footer-h">{{ $t("navBottom.bottomCompany") }}</div>
          <div class="bb-social">
            <div v-for="item in links" :key="item.type" class="bb-social-item" @click="toLinkPage(item)">
              <img v-if="item.type === 'discord'" src="@/assets/img/icon_discord.08727466.svg" alt="" />
              <img v-else-if="item.type === 'twitter'" src="@/assets/img/icon_twitter.667925f3.svg" alt="" />
              <img v-else-if="item.type === 'telegram'" src="@/assets/img/icon_telegram.83daadb6.svg" alt="" />
            </div>
          </div>
        </section>
        <section class="bb-footer-col">
          <h2>{{ $t("navBottom.bottomCompany") }}</h2>
          <div class="bb-footer-links">
            <a v-for="(item, index) in company" :key="'c' + index" @click.prevent="toDetail(item)">{{ item.title }}</a>
          </div>
        </section>
        <section class="bb-footer-col">
          <h2>{{ $t("navBottom.bottomProduct") }}</h2>
          <div class="bb-footer-links">
            <a @click.prevent="$router.push('/market')">{{ $t("navBottom.bottomProductItem1") }}</a>
            <a @click.prevent="$router.push('/loan')">{{ $t("navBottom.bottomProductItem2") }}</a>
            <a @click.prevent="$router.push('/nfts')">{{ $t("navBottom.bottomProductItem3") }}</a>
            <a @click.prevent="$router.push('/trading')">{{ $t("navBottom.bottomProductItem4") }}</a>
            <a @click.prevent="$router.push('/tokenSale')">{{ $t("navTab.tabMenu8") }}</a>
          </div>
        </section>
        <section class="bb-footer-col">
          <h2>{{ $t("navBottom.bottomPolicy") }}</h2>
          <div class="bb-footer-links">
            <a v-for="(item, index) in policy" :key="'p' + index" @click.prevent="toDetail(item)">{{ item.title }}</a>
            <a @click.prevent="openService">{{ $t("home.onlineSupport") }}</a>
          </div>
        </section>
        <section class="bb-footer-col">
          <h2>{{ $t("navTab.tabMenu1") }}</h2>
          <div class="bb-footer-links">
            <a v-for="(item, index) in footer" :key="'f' + index" @click.prevent="toDetail(item)">{{ item.title }}</a>
          </div>
        </section>
      </div>
    </div>
    <div class="bb-footer-line"></div>
    <div class="bb-copy">© {{ year }} {{ title }}. All rights reserved</div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
import { postCustomerServiceFooterApi } from "@/api";
import { openCustomerService } from "@/utils/customerService";
import BrandLogo from "@/components/BrandLogo.vue";

export default {
  name: "NavBottomPc",
  components: { BrandLogo },
  computed: {
    ...mapGetters(["getContentList", "getUserInfo"]),
    title() {
      return this.$store.state.siteName || "Galaxy Digital";
    },
    year() {
      return new Date().getFullYear();
    }
  },
  watch: {
    getContentList: {
      handler(val) {
        this.company = val.filter((item) => item.type == 1);
        this.policy = val.filter((item) => item.type == 2);
        this.footer = val.filter((item) => item.type == 3);
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      company: [],
      policy: [],
      footer: [],
      links: []
    };
  },
  methods: {
    openService() {
      openCustomerService(this);
    },
    toDetail(item) {
      if (this.$route.query.id == item.id) {
        return;
      }
      this.$router.push({ path: "/detail", query: { id: item.id, title: item.title } });
    },
    toAboutPage() {
      if (this.$route.name === "about") {
        return;
      }
      this.$router.push({ path: "/about" });
    },
    getLinkData() {
      postCustomerServiceFooterApi().then((res) => {
        if (res && res.items) {
          this.links = [...res.items];
        }
      });
    },
    toLinkPage(item) {
      item.url && window.open(item.url, "_blank");
    }
  }
};
</script>
<style scoped>
.bb-footer {
  background: var(--bb-bg);
  color: var(--bb-text);
  font-size: 16px;
}
.bb-footer-main {
  width: 100%;
  padding: 64px 16px 0;
}
.bb-footer-grid {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 24px;
}
.bb-footer-brand {
  min-width: 0;
  flex: 1;
  max-width: 208px;
}
.bb-footer-logo {
  color: var(--bb-text);
  margin-bottom: 48px;
  cursor: pointer;
  display: inline-block;
}
.bb-footer-h {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 20px;
}
.bb-social {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 24px;
}
.bb-social-item {
  width: 20px;
  height: 20px;
  cursor: pointer;
  opacity: 0.7;
}
.bb-social-item:hover {
  opacity: 1;
}
.bb-social-item img {
  width: 100%;
  height: 100%;
  filter: var(--bb-icon-filter);
}
.bb-footer-col {
  min-width: 0;
  flex: 1;
  max-width: 200px;
  margin-top: 74px;
}
.bb-footer-col h2 {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px;
  color: var(--bb-text);
}
.bb-footer-links {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.bb-footer-links a {
  font-size: 14px;
  color: var(--bb-text-tertiary);
  cursor: pointer;
  padding: 4px 0;
}
.bb-footer-links a:hover {
  color: var(--bb-text);
}
.bb-footer-line {
  margin-top: 48px;
  height: 1px;
  width: 100%;
  background: var(--bb-divider);
}
.bb-copy {
  padding: 24px 16px;
  text-align: center;
  font-size: 12px;
  color: var(--bb-text-tertiary);
}
</style>
